export const siteLinks = {
    todo: {
        dev: '//devtodo.guazi-cloud.com',
        test: '//testtodo.guazi-cloud.com',
        uat: '//uattodo.guazi-cloud.com',
        online: '//todo.guazi.com',
    },
    lawSign: {
        dev: '//devlaw-sign.guazi-cloud.com',
        test: '//testlaw-sign.guazi-cloud.com',
        uat: '//uatlaw-sign.guazi-cloud.com',
        online: '//law-sign.guazi.com',
    },
}
